/*
 *  -----------------------------------------------------------------------
 *    <copyright file="reports/risk-overview-section.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';

import LegendIcons from '@components/central-monitoring/legend-icons/legend-icons';
import { useTranslation } from 'hooks';
import { StudyFields } from 'queries/generated/fragments.generated';
import PreviewExpandable from 'views/components/central-monitoring/reports/preview-expandable';
import RiskOverviewGrid from 'views/components/central-monitoring/reports/risk-overview-grid';
import { ProcessedStudyDataResponse } from '@apis/bff-api/studies';

const RiskOverviewSection = ({
    processedData,
    study,
    riskOverviews,
    riskOverviewColumns,
}: {
    processedData: ProcessedStudyDataResponse | null;
    study: StudyFields;
    riskOverviews: any;
    riskOverviewColumns: any;
}) => {
    const { t } = useTranslation();

    return (
        <PreviewExpandable header={t('cm:riskOverview')} isExpanded={false}>
            <div className="risk-oveview-wrapper">
                <LegendIcons />
                <div style={{ marginBottom: 10 }}>
                    <RiskOverviewGrid
                        hideColumnMenu
                        showActions={false}
                        studyData={processedData}
                        config={{
                            riskOverview: study?.riskOverviewConfiguration,
                        }}
                        sitesStatusesToExclude={study?.sitesStatusesToExclude}
                        riskOverviewColumns={riskOverviewColumns}
                        riskOverviews={riskOverviews}
                        isExcludeSites={false}
                    />
                </div>
            </div>
        </PreviewExpandable>
    );
};

export default RiskOverviewSection;
